import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-garage-developer-guide/ibm-garage-developer-guide/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Globals from 'gatsby-theme-carbon/src/templates/Globals';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ArticleCard = makeShortcode("ArticleCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Provides information for a system administrator on how to use and extend the Toolkit components to manage the
cloud environments. `}</p>
    </PageDescription>
    <Row mdxType="Row">
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Configure the dashboard" subTitle="Customize the Developer Dashboard and OpenShift console" href="/admin/config-dashboard" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.66666666666666%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEBf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAYXx6hmCA//EABkQAAMBAQEAAAAAAAAAAAAAAAABAhEDBP/aAAgBAQABBQKaR1sVHKdv2SsxH//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABoQAAICAwAAAAAAAAAAAAAAAAABAhAxQWH/2gAIAQEABj8C0LAyK6Rdf//EABsQAQACAwEBAAAAAAAAAAAAAAEAESExQVFx/9oACAEBAAE/IbT1eFhpYGNQPG4SHaTEFcly/Z//2gAMAwEAAgADAAAAEDsP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQIBAT8Qp//EABsQAQADAAMBAAAAAAAAAAAAAAEAESExQVFh/9oACAEBAAE/EAA0tehSRtyIU7rmXkum8zWje/LI0pQZPAybESkYz//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "sysadmins2",
              "title": "sysadmins2",
              "src": "/dev-guide/static/dba5f615522e72f3748d545d53073859/2e753/sysadmins2.jpg",
              "srcSet": ["/dev-guide/static/dba5f615522e72f3748d545d53073859/69549/sysadmins2.jpg 288w", "/dev-guide/static/dba5f615522e72f3748d545d53073859/473e3/sysadmins2.jpg 576w", "/dev-guide/static/dba5f615522e72f3748d545d53073859/2e753/sysadmins2.jpg 1152w", "/dev-guide/static/dba5f615522e72f3748d545d53073859/74f4b/sysadmins2.jpg 1728w", "/dev-guide/static/dba5f615522e72f3748d545d53073859/de5bb/sysadmins2.jpg 2304w", "/dev-guide/static/dba5f615522e72f3748d545d53073859/cab92/sysadmins2.jpg 2500w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Infrastructure as Code" subTitle="Review the framework and modules that provide Infrastructure as Code scripts" href="/admin/terraform" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1002px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.66666666666666%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAABAACA//EABYBAQEBAAAAAAAAAAAAAAAAAAEAAv/aAAwDAQACEAMQAAABPk7WBc7R/8QAGhABAQACAwAAAAAAAAAAAAAAAgEAAxESIf/aAAgBAQABBQIVSdkspXOv1bRCbbn/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAXEQEAAwAAAAAAAAAAAAAAAAAAASEx/9oACAECAQE/AZ1T/8QAGxAAAgEFAAAAAAAAAAAAAAAAABABERIhQYH/2gAIAQEABj8Ct0cqoML/xAAZEAEBAQEBAQAAAAAAAAAAAAABEQAxIUH/2gAIAQEAAT8h8sr6XSQlB4zONQH7i6YwNd13/9oADAMBAAIAAwAAABDDz//EABcRAQEBAQAAAAAAAAAAAAAAAAEAESH/2gAIAQMBAT8QFy7f/8QAFREBAQAAAAAAAAAAAAAAAAAAARD/2gAIAQIBAT8QBD//xAAbEAEBAAMBAQEAAAAAAAAAAAABEQAhMUFRcf/aAAgBAQABPxB0oIyeHR/cnAwjpLe7y4aXqpjXqIG56zA71vIELX3P/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "sysadmins",
              "title": "sysadmins",
              "src": "/dev-guide/static/c416dfbbacfaea1aa920491f05c55409/0c625/sysadmins.jpg",
              "srcSet": ["/dev-guide/static/c416dfbbacfaea1aa920491f05c55409/69549/sysadmins.jpg 288w", "/dev-guide/static/c416dfbbacfaea1aa920491f05c55409/473e3/sysadmins.jpg 576w", "/dev-guide/static/c416dfbbacfaea1aa920491f05c55409/0c625/sysadmins.jpg 1002w"],
              "sizes": "(max-width: 1002px) 100vw, 1002px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Cluster configuration" subTitle="Understand the metadata used to configure the cluster and the tools to customize and manage the environment" href="/admin/cluster-configuration" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1000px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.66666666666666%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAQD/8QAFwEAAwEAAAAAAAAAAAAAAAAAAQIDBP/aAAwDAQACEAMQAAABxkvjlvxBT//EABoQAQABBQAAAAAAAAAAAAAAAAIRAAMQMTL/2gAIAQEAAQUCuGDGH0tV/8QAFhEBAQEAAAAAAAAAAAAAAAAAAREQ/9oACAEDAQE/AUJc/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFBABAAAAAAAAAAAAAAAAAAAAIP/aAAgBAQAGPwJf/8QAGxAAAwACAwAAAAAAAAAAAAAAAAERITFRYXH/2gAIAQEAAT8hwGL0iZpEFcJu1cDz0U//2gAMAwEAAgADAAAAEFMP/8QAFhEBAQEAAAAAAAAAAAAAAAAAAQAh/9oACAEDAQE/ENxCX//EABYRAQEBAAAAAAAAAAAAAAAAAAEREP/aAAgBAgEBPxAWzP/EABoQAQEBAQADAAAAAAAAAAAAAAERADEhcZH/2gAIAQEAAT8QoI6WYPzLlAfXlwCy4wsKwibk4Lf/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "code2",
              "title": "code2",
              "src": "/dev-guide/static/d41e8261a5cf31d7c026b62f70377e00/4edc6/code2.jpg",
              "srcSet": ["/dev-guide/static/d41e8261a5cf31d7c026b62f70377e00/69549/code2.jpg 288w", "/dev-guide/static/d41e8261a5cf31d7c026b62f70377e00/473e3/code2.jpg 576w", "/dev-guide/static/d41e8261a5cf31d7c026b62f70377e00/4edc6/code2.jpg 1000w"],
              "sizes": "(max-width: 1000px) 100vw, 1000px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      